import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";
import Modal from "react-modal";

const AgronomyDetailList = (props) => {
  const { addForm, update } = props;
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [images, setImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selecteditem, setSelecteditem] = useState(null);

  const imageGroups = [];
  for (let i = 0; i < images.length; i += 4) {
    imageGroups.push(images.slice(i, i + 4));
  }

  const { sendRequest: getAgronomyData } = useHttp();

  const getAgronomyDetail = () => {
    getAgronomyData(
      {
        url: `/api/farmerCropObservationViewList/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem("empId")}`,
      },
      (res) => {
        console.log("res", res);
        if (res) {
          setData(res);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    getAgronomyDetail();
  }, [setData]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: deleteOperation } = useHttp();

  const handleDelete = (e, agronomyId) => {
    e.preventDefault();

    const data = {
      agronomyId: agronomyId,
    };

    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this sowing detail?",
      onOk() {
        deleteOperation(
          {
            url: `/api/farmerCropObservationViewList/`,
            method: "DELETE",
            body: data,
          },
          (data) => {
            if (data.success) {
              toast.success(data.success);
            }

            if (data.error) {
              toast.error(data.error);
            }
            getAgronomyDetail();
          }
        );
      },
      onCancel() {},
    });
  };
  const handleSearch = (e) => {
    var filtertext = e.target.value.trim().toLowerCase();

    var filterdata = allData.filter(
      (item) =>
        item.farmerName?.toLowerCase().includes(filtertext) ||
        item.farmerNo?.toLowerCase().includes(filtertext) ||
        item.executiveName?.toLowerCase().includes(filtertext) ||
        item.areaName.toLowerCase().includes(filtertext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");
  const [selectedAgronomyDetail, setSelectedAgronomyDetail] = useState(null);
  const [approvalPopupVisible, setApprovalPopupVisible] = useState(false);

  const [loading, setLoading] = useState({
    approve: false,
    disapprove: false,
    sendNextApprove: false,
  });

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        // console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);

  const [remark, setRemark] = useState("");

  const { sendRequest: updateApprovalStatus } = useHttp();

  const showApprovalPopup = (expense) => {
    // console.log(expense);
    setSelectedAgronomyDetail(expense);
    setApprovalPopupVisible(true);
  };

  const handleRemarkChange = (e) => {
    setRemark(e.target.value);
  };

  const handleApprovalSubmit = (status) => {
    const approvalStatus = status || "";
    // console.log(approvalStatus);

    setLoading((prevState) => ({ ...prevState, [status]: true }));
    let data = "";
    const getApprovalData = (approvalStatus) => {
      const baseData = {
        agronomyId: selectedAgronomyDetail && selectedAgronomyDetail.agronomyId,
        approvedBy: parseInt(localStorage.getItem("empId")),
        serviceId: serviceId,
        nextlevel: 0,
        orgId: parseInt(localStorage.getItem("orgId")),
        remark: remark,
      };

      switch (approvalStatus) {
        case "approve":
          return { ...baseData, approved: 1 };
        case "disapprove":
          return { ...baseData, approved: 2 };
        case "sendNextApprove":
          return { ...baseData, approved: 0, nextlevel: 1 };
        default:
          return baseData;
      }
    };

    data = getApprovalData(approvalStatus);

    // console.log(data);

    updateApprovalStatus(
      {
        url: "/api/farmerCropObservationapproval/",
        method: "PUT",
        body: data,
      },
      (data) => {
        toast.success(data);
        getAgronomyDetail();
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });

        setApprovalPopupVisible(false);
        setRemark("");
      },
      () => {
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });
      }
    );
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "100%",
      width: "600px",
      height: "100%",
      minHeight: "300px",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [AgroFertilizerData, setAgroFertilizerData] = useState([]);

  const openModal = (id) => {
    if (id) {
      getAgronomyData(
        {
          url: `/api/farmerCropObservationViewList/?agronomyId=${id}&orgId=${localStorage.getItem(
            "orgId"
          )}`,
        },
        (res) => {
          // console.log("res",res);
          if (res) {
            setSelectedData(res);
            const agroFertilizers = JSON.parse(res.agroFertilizers);
            const formattedData = agroFertilizers.map((item) => ({
              date: item.date,
              fertilizerName: item.fertilizerName,
              quantity: item.quantity,
              unit: item.unit,
            }));
            setAgroFertilizerData(formattedData);

            const cropObservationObj = JSON.parse(res.cropObservation);
            const imageUrls = JSON.parse(
              cropObservationObj.cropObservationAttachment
            ).map(
              (item) =>
                `${process.env.REACT_APP_FILE_URL}${item.urlAttachments}`
            );
            setImages(imageUrls);
          }
        }
      );
    }
    setIsModalOpen(true);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row">
          <div className="col-6">
            <label className="card-title mx-2 my-3">
              {" "}
              &nbsp; &nbsp;Sowing Details{" "}
            </label>{" "}
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-9"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          placeholder="Search..."
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                        />{" "}
                        <br />
                      </div>
                    </div>
                    <div className="row">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th>Farmer Name</th>
                            <th>Identification No</th>
                            <th>Field Executive</th>
                            <th>Area</th>
                            <th>Edit</th>
                            <th>Approval</th>
                            {/* <th>Approved By</th> */}
                            <th>View</th>
                            <th>Status</th>
                            <th>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.farmerName}</td>
                                <td>{x.farmerNo}</td>
                                <td>{x.executiveName}</td>
                                <td>{x.areaName}</td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => {
                                      props.update(x);
                                      props.addForm(true);
                                    }}
                                    disabled={
                                      x.approved === 1 || x.approved === 2
                                    }
                                  >
                                    {" "}
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    type="button"
                                    onClick={() => showApprovalPopup(x)}
                                    disabled={
                                      x.approved === 1 || x.approved === 2
                                    }
                                  >
                                    {x.approved == 1 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "green" }}
                                      ></i>
                                    ) : x.approved == 2 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "red" }}
                                      ></i>
                                    ) : (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "gray" }}
                                      ></i>
                                    )}
                                  </button>
                                </td>
                                {/* <td>{x.approvedBy}</td> */}
                                <td>
                                  <button
                                    type="button"
                                    onClick={() => openModal(x.agronomyId)}
                                    className="btn"
                                  >
                                    {" "}
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                                <td>
                                  {x.status == 1 ? "Active" : "In-Active"}
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={(e) =>
                                      handleDelete(e, x.agronomyId)
                                    }
                                    disabled={
                                      x.approved === 1 || x.approved === 2
                                    }
                                  >
                                    {" "}
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {/* view modal */}
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div>
            <h4 className="card-title font-weight-bold">Sowing Details</h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Sowing Date: {selectedData.date}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Irrigation Date: {selectedData.irrigationDate}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Field Opeartion Description:{" "}
                {selectedData.fieldOperationDescription}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Transplanted Area: {selectedData.transplantedArea}
              </p>
            </div>
            {/* <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Plant Count: {selectedData.plantCount}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Average Leaves Par Plant: {selectedData.averageLeavesPerPlant}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Diseases/ Insect pest Observed:{" "}
                {selectedData.insectDiseasePestName}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Affected Area: {selectedData.affectedArea}
              </p>
            </div> */}

            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Sowing Method: {selectedData.sowingMethod}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Seed Source: {selectedData.seedSource}
              </p>
            </div>
            <div className="row">
              <p className="col-md-12" style={{ textAlign: "left" }}>
                Land Preparation Type: {selectedData.landPreparationType}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Estimated Yield(Kg): {selectedData.estimateYield}
              </p>
            </div>

            <div className="row">
              <div class="card col-md-12">
                <p className="font-weight-bold">Agro-Chemical/Fertilizer</p>
                {AgroFertilizerData.map((item, index) => (
                  <div key={index}>
                    <p style={{ textAlign: "left", margin: "0.5rem 0" }}>
                      Date: {item.date}
                    </p>
                    <p style={{ textAlign: "left", margin: "0.5rem 0" }}>
                      Fertilizer Name: {item.fertilizerName}
                    </p>
                    <p style={{ textAlign: "left", margin: "0.5rem 0" }}>
                      Quantity: {item.quantity} {item.unit}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className="row">
              <p>Recommendation: {selectedData.recommendation}</p>
            </div>
            <div className="row">
              <p>Crop Observation:</p>
            </div>
            <div className="row">
              <div className="card col-md-12">
                <div
                  id="carouselExampleCustom"
                  className="carousel slide"
                  style={{ position: "relative" }}
                >
                  <div className="carousel-inner">
                    {imageGroups.length > 0 ? (
                      imageGroups.map((group, index) => (
                        <div
                          key={index}
                          className={`carousel-item ${
                            index === currentIndex ? "active" : ""
                          }`}
                        >
                          <div className="row w-50px">
                            {group.map((image, idx) => (
                              <div key={idx} className="col-3">
                                <img
                                  src={image}
                                  className="d-block w-100"
                                  alt={`Observation ${index * 4 + idx + 1}`}
                                  style={{
                                    borderRadius: "5px",
                                    objectFit: "fill",
                                    height: "200px",
                                    width: "100px",
                                  }}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      ))
                    ) : (
                      <p style={{ textAlign: "left" }}>No images available</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <p>Description: {selectedData.description}</p>
          </div>
        )}
      </Modal>
      <AntModal
        title="Agronomy Detail Approval"
        open={approvalPopupVisible}
        onCancel={() => setApprovalPopupVisible(false)}
        footer={null}
      >
        <label>Remarks:</label>
        <textarea
          rows={3}
          value={remark}
          className="form-control"
          onChange={handleRemarkChange}
        />
        <br />
        <div>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("approve")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.approve ? "Approving..." : "Approve"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            onClick={() => handleApprovalSubmit("disapprove")}
            className="btn btn-sm btn-primary"
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.disapprove ? "Disapproving..." : "Disapprove"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("sendNextApprove")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.sendNextApprove ? "Sending..." : "Send Next Approve"}
          </button>
        </div>
      </AntModal>
    </>
  );
};

export default AgronomyDetailList;
